module.exports = __webpack_public_path__ + "assets/img/27-s.bc7b287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/27-s.jpg
// module id = Hufu
// module chunks = 0